module.exports = __webpack_public_path__ + "img/cotizacion.072ea7ef.png";